export const formatDate = (dateString) => {
  const options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(dateString).toLocaleDateString("en-US", options);
};

export const searchProducts = (products, searchTerm) => {
  if (!searchTerm) return products;

  const lowercasedTerm = searchTerm?.toLowerCase() || "";
  return (
    products?.filter(
      (product) =>
        product.title?.toLowerCase()?.includes(lowercasedTerm) ||
        product.source?.toLowerCase()?.includes(lowercasedTerm) ||
        product.status?.toLowerCase()?.includes(lowercasedTerm)
    ) || []
  );
};

export const sortProducts = (products, sortBy, sortOrder) => {
  const sortedProducts = [...products];

  if (sortBy === "created") {
    sortedProducts.sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });
  }

  return sortedProducts;
};

const generateUniqueId = (prefix) => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 8);
  return `${prefix}_${timestamp}_${random}`;
};

export const manageAgentSessionIds = (isForceChange = false) => {
  if (isForceChange) {
    localStorage.removeItem("agentId");
    localStorage.removeItem("sessionId");
  }
  let agentId = localStorage.getItem("agentId");
  let sessionId = localStorage.getItem("sessionId");

  if (!agentId) {
    agentId = generateUniqueId("agent");
    localStorage.setItem("agentId", agentId);
  }

  if (!sessionId) {
    sessionId = generateUniqueId("session");
    localStorage.setItem("sessionId", sessionId);
  }

  return { agentId, sessionId };
};

// export const generateNewAgentSessionIds = () => {
//   const agentId = generateUniqueId("agent");
//   const sessionId = generateUniqueId("session");
//   return { agentId, sessionId };
// };

export const addOpacity = (color, alpha) => {
  // hex (#abc or #aabbcc)
  let m = color.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (m) {
    let hex =
      m[1].length === 3
        ? m[1]
            .split("")
            .map((c) => c + c)
            .join("")
        : m[1];
    let v = parseInt(hex, 16);
    let r = (v >> 16) & 255;
    let g = (v >> 8) & 255;
    let b = v & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // rgb(...) or rgba(...)
  m = color.match(
    /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*[\d.]+)?\s*\)$/
  );
  if (m) {
    return `rgba(${m[1]}, ${m[2]}, ${m[3]}, ${alpha})`;
  }

  // otherwise, just return what you passed in
  return color;
};

/**
 * Get agent ID for a specific agent type from localStorage
 * @param {string} agentType - The agent type (e.g., 'KeywordClusterSmith', 'BlogForgeFinal', 'OutlineArchitect')
 * @returns {string|null} - The agent ID or null if not found
 */
export const getAgentId = (agentType) => {
  try {
    const agentIntegrations = localStorage.getItem('agent_integrations');
    if (!agentIntegrations) {
      console.warn(`Agent integrations not found in localStorage`);
      return null;
    }
    
    const integrations = JSON.parse(agentIntegrations);
    return integrations[agentType] || null;
  } catch (error) {
    console.error(`Error getting agent ID for ${agentType}:`, error);
    return null;
  }
};